module.exports = __webpack_public_path__ + "media/dashboard/assets/images/external/peasylogo-ea3e346fdf4e27957f079b9b94ec9c7a.png";